import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SessionState } from '../reducers/session.reducer';
import { SESSION_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<SessionState>(SESSION_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: SessionState) => state.loaded);
export const selectPermissions = createSelector(selectState, (state: SessionState) => state.permissions);
export const selectHasPermissionsWildcard = createSelector(selectState, (state: SessionState) => state.hasPermissionsWildcard);
